import { useContext, useEffect, useState } from "react";
import { GET_ALL_STUDENT_TALK, fetchData } from "../../../components/Service";
import { Context } from "../../../components/Context";
import _ from "lodash";
import moment from "../../../../node_modules/moment/moment";
import { Link } from "../../../../node_modules/react-router-dom/dist/index";

const StudentTalk = () => {
	const [stuTalk, setStuTalk] = useState([]);
	const [activeTab, setActiveTab] = useState("");
	const [context] = useContext(Context);

	const getForum = (country_id, state_id) => {
		let payload = {
			country_id: country_id,
			state_id: state_id,
		};
		fetchData(GET_ALL_STUDENT_TALK, "POST", payload, false, false, (res) => {
			if (res.status) {
				setStuTalk(res?.data?.data);
				setActiveTab(res?.data?.data[0]?.id);
			} else {
				console.log(res);
			}
		});
	};

	useEffect(() => {
		if (context?.countryId && context?.stateId) {
			getForum(context?.countryId, context?.stateId);
		}
	}, [context]);
	return (
		<div class="col-lg-4 mb-1">
			<div class="card card-forum h-100">
				<div class="card-header usa-bg">
					<div className="national-bg">
						<div class="row ind1">
							<div class="col-sm-4">
								<h4 class="text-white d-flex">Student's Talk</h4>
							</div>
							<div class="col-sm-8 text-end">
								<ul class="nav nav-tabs position-relative" role="tablist">
									{stuTalk?.map((item) => (
										<li key={item.id}>
											<a
												class={activeTab === item.id ? "active" : ""}
												id={`nav-student-tab-${item.id}`}
												href={`#student-tab-${item.id}`}
												data-bs-toggle="tab"
												role="tab"
												aria-controls={`student-tab-${item.id}`}
												aria-selected={activeTab === item.id}
											>
												{item.name}
											</a>
										</li>
									))}
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div class="card-body bg-white news_scroll p-1">
					<div class="tab-content">
						{stuTalk?.map((item) => (
							<div
								key={item.id}
								class={activeTab === item.id ? `tab-pane fade show active` : `tab-pane fade`}
								id={`student-tab-${item.id}`}
								role="tabpanel"
								aria-labelledby={`student-tab-${item.id}`}
							>
								<div class="table-responsive">
									<table class="table table-borderless table-sm align-middle">
										{item?.category_data?.slice(0, 10)?.map((stuItem) => (
											<tr key={stuItem.id}>
												<td>
													<Link to={`/student-talks/${stuItem.id}`}>
														<img src="/assets/images/icons/map-pin.png" class="me-2" alt="..."/>
														{_.truncate(stuItem?.university?.name, { length: 20 })}
													</Link>{" "}
												</td>
												<td class="fw-bold">
													<Link to={`/student-talks/${stuItem.id}`}>{_.truncate(stuItem?.title, { length: 20 })}</Link>
												</td>
												<td class="text-end text-nowrap">{stuItem.created_at ? moment(stuItem.created_at).format("DD-MMM-YYYY") : ""}</td>
											</tr>
										))}
									</table>
								</div>
							</div>
						))}
					</div>
				</div>
				<div class="card-footer text-end py-1">
					<span class="font16 fw-normal ms-auto">
						<Link to={`/student-talks`} class="text-decoration-underline font11">
							View More
						</Link>
					</span>
				</div>
			</div>
		</div>
	);
};

export default StudentTalk;
